export default {
  title: 'pink',

  colors: {
    twitter: 'rgb(187, 45, 90)',
    darkhover: '#160409',
    lighthover: '#2F2028',
  },
};